// extracted by mini-css-extract-plugin
export default {"headerCell":"NhE1M"};